import { EventEmitter, inject, Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GastRequestWithBodyModel, HttpService } from 'gast-common-ng2';
import { BookingMappingDto } from '../dtos/booking-mapping-dto';
import { BookingDto } from '../dtos/booking/booking-dto';
import { UrlService } from './common/url.service';

@Injectable({
    providedIn: 'root',
})
export class OnsetService {
    checkTanCompleted: EventEmitter<Boolean> = new EventEmitter();
    bookingMappingLoaded: EventEmitter<BookingMappingDto> = new EventEmitter();
    bookingMappingSaved: EventEmitter<Array<BookingMappingDto>> = new EventEmitter();
    bookingStudyLoaded: EventEmitter<BookingDto> = new EventEmitter();
    checkIfEnoughMobileParticipantDone: EventEmitter<boolean> = new EventEmitter();

    readonly #httpService = inject(HttpService);
    readonly #http = inject(HttpClient);
    readonly #urlService = inject(UrlService);

    createBookingMappingForBooking(bookingDto: BookingDto, username: string): void {
        const callback = (found: Array<BookingMappingDto>) => {
            this.bookingMappingSaved.emit(found);
        };

        const errorCallback = (error: HttpErrorResponse) => {
            console.log(' cannot save booking mapping');
        };

        const url = this.#urlService.createOnsetBookingForOnsetStudy(username);

        const request = {
            method: 'POST',
            mapper: (response: Response) => <any>response.json(),
            callback: callback,
            body: bookingDto,
            url: url
        } as GastRequestWithBodyModel<any, BookingDto>;
        this.#http.post<Array<BookingMappingDto>>(url, bookingDto, { withCredentials: true, responseType: 'json' })
            .subscribe(callback, errorCallback);
    }

    createOnsetBookingStudy(): void {
        const callback = (found: BookingDto) => {
            this.bookingStudyLoaded.emit(found);
        };

        const errorCallback = (error: HttpErrorResponse) => {
            console.log(' cannot create onset booking for study');
        };

        const url = this.#urlService.createGastBookingForOnsetStudy();

        const request = {
            method: 'POST',
            mapper: (response: Response) => <any>response.json(),
            callback: callback,
            body: null,
            url: url
        } as GastRequestWithBodyModel<any, null>;
        this.#httpService.post(request, errorCallback);
    }

    checkIfEnoughMobileParticipantForOnsetStudy(): void {
        const successCallback = (result: String) => {
            const booleanValue = result == 'true' ? true : false;
            this.checkIfEnoughMobileParticipantDone.emit(booleanValue);
        };

        const errorCallback = (error: HttpErrorResponse) => {
            console.log(error);
        };

        const url = this.#urlService.checkIfAlreadyEnoughParticipantForMobileVersion();
        this.#http.get(url, { withCredentials: true, responseType: 'text' })
            .subscribe(successCallback, errorCallback);
    }
}
